export const limitCalls = (fn, times) => {
  var memo
  return function () {
    if (times-- > 0) {
      memo = fn.apply(this, arguments)
    } else {
      fn = null
    }
    return memo
  }
}

export const once = fn => limitCalls(fn, 1)
